import moment from 'moment';
import { useMemo } from 'react';
import ReactTable from 'react-table';
import type {
  PageChangeFunction,
  PageSizeChangeFunction,
  RowRenderProps,
  SortedChangeFunction,
} from 'react-table';
import Icon, { icons } from '../../generic/Icon';
import type { AuditLog } from '../../../types';
import styles from './AuditLogs.module.less';

type IAuditLogTableProps = {
  isLoading: boolean;
  logs: AuditLog[];
  logCount: number;
  pageSize: number;
  page: number;
  onPageChange: PageChangeFunction;
  onPageSizeChange: PageSizeChangeFunction;
  onSortedChange: SortedChangeFunction;
};

const columnSortIndicator = (
  <span className="pull-right">
    <Icon icon={icons.caretDown} />
    <Icon icon={icons.caretUp} />
  </span>
);

const AuditLogTable = (props: IAuditLogTableProps) => {
  const columns = useMemo(() => [{
    Header: (
      <div>
        Email or Username
        {columnSortIndicator}
      </div>
    ),
    accessor: 'actingUserName',
    width: 200,
    style: { textOverflow: 'ellipsis' },
  }, {
    Header: (
      <div>
        Role
        {columnSortIndicator}
      </div>
    ),
    accessor: 'actingUserRole',
    width: 120,
    style: { textOverflow: 'ellipsis' },
  }, {
    Header: (
      <div>
        Date
        {columnSortIndicator}
      </div>
    ),
    accessor: 'createdAt',
    width: 180,
    style: { overflow: 'visible' },
    // eslint-disable-next-line react/no-unstable-nested-components
    Cell: (rowRenderProps: RowRenderProps) => {
      if (rowRenderProps.value) {
        const createdAt = moment(rowRenderProps.value, moment.ISO_8601);
        return (
          <span title={createdAt.calendar()}>
            {createdAt.format('l')}&nbsp;{createdAt.format('LTS')}
          </span>
        );
      }
      return null;
    },
  }, {
    Header: (
      <div>
        Action
        {columnSortIndicator}
      </div>
    ),
    accessor: 'description',
    style: { overflow: 'scroll', textOverflow: 'clip' },
  }], []);

  return (
    <div className={styles.table}>
      <ReactTable
        data={props.logs}
        columns={columns}
        minRows={5}
        manual
        loading={props.isLoading}
        page={props.page}
        pages={Math.ceil(props.logCount / props.pageSize)}
        collapseOnDataChange={false}
        collapseOnSortingChange={false}
        onPageChange={props.onPageChange}
        onPageSizeChange={props.onPageSizeChange}
        onSortedChange={props.onSortedChange}
        defaultPageSize={props.pageSize}
        defaultSorted={[{
          id: 'createdBy',
          desc: false,
        }]}
      />
    </div>
  );
};

export default AuditLogTable;
